// extracted by mini-css-extract-plugin
export default {"container":"FormContainer_container__e-HjF","title":"FormContainer_title__Hbhld","subtitle":"FormContainer_subtitle__oxxs7","inputContainer":"FormContainer_inputContainer__pETnn"};